import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-inline-flex align-center justify-space-between",
  style: {"gap":"5px"}
}
const _hoisted_2 = { class: "d-flex justify-end w-100" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "ms-2" }
const _hoisted_5 = {
  class: "d-inline-flex align-center justify-space-between",
  style: {"gap":"5px"}
}
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "ms-2" }
const _hoisted_8 = {
  class: "d-inline-flex align-center justify-space-between",
  style: {"gap":"5px"}
}
const _hoisted_9 = { class: "mb-7" }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = { class: "ms-2" }
const _hoisted_12 = {
  class: "d-inline-flex align-center justify-space-between",
  style: {"gap":"5px"}
}
const _hoisted_13 = { class: "d-flex" }
const _hoisted_14 = { class: "ms-2" }
const _hoisted_15 = {
  class: "d-inline-flex align-center justify-space-between",
  style: {"gap":"5px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" <AtomTitle title=\"Grupos\" /> "),
    _createVNode($setup["MoleculeTitleSetings"], {
      addBtn: $setup.addNew,
      title: $setup.type == 'C' ? 'Cadastro de Grupos' : $setup.type == 'E' ? 'Editando Grupo' : 'Grupos',
      onHandleConfirm: $setup.replacement
    }, null, 8 /* PROPS */, ["addBtn", "title"]),
    (!$setup.addNew && !$setup.manageGroup && !$setup.manageService)
      ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode($setup["MoleculeTable"], {
                  onChangePerPage: _cache[1] || (_cache[1] = (ev) => ($setup.perPage = ev)),
                  onChangePage: _cache[2] || (_cache[2] = (ev) => ($setup.page = ev)),
                  onBlur: $setup.searching,
                  onHandleSort: $setup.sort,
                  filters: "",
                  headers: $setup.headers,
                  items: $setup.items,
                  totalItems: $setup.totalItems,
                  perPage: $setup.perPage,
                  page: $setup.page,
                  onItemClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.handleEdit($event, true))),
                  onItemClickDelete: _cache[4] || (_cache[4] = ($event: any) => ($setup.handleDelete($event)))
                }, {
                  actions: _withCtx(({ props }) => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode($setup["AtomButton"], {
                        background: "white",
                        radius: "",
                        class: "pa-0",
                        onClick: _withModifiers(($event: any) => ($setup.handleEdit(props.row)), ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode($setup["EditSquareIcon"])
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                      _createVNode($setup["AtomButton"], {
                        background: "white",
                        radiusOutlined: "",
                        class: "pa-2",
                        onClick: _withModifiers(($event: any) => ($setup.handleCompany(props.row)), ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode($setup["ActivityIcon"])
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                      _createVNode($setup["AtomButton"], {
                        background: "white",
                        radiusOutlined: "",
                        class: "pa-2",
                        onClick: _withModifiers(($event: any) => ($setup.handleAdd(props.row)), ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode($setup["WorkIcon"])
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                      (props.row.archived == 0)
                        ? (_openBlock(), _createBlock($setup["AtomButton"], {
                            key: 0,
                            background: "white",
                            radius: "",
                            class: "pa-0",
                            onClick: _withModifiers(($event: any) => ($setup.handleDelete(props.row)), ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode($setup["DeleteIcon"])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  areaFilter: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createCommentVNode(" <AtomButton background=\"white\" text=\"Gerar relatório mensal\" outlined> </AtomButton> "),
                      _createVNode($setup["AtomButton"], {
                        class: "ms-2",
                        text: "Novo Grupo",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => {
                $setup.clear();
                $setup.showModalUpload = true;
              })
                      })
                    ])
                  ]),
                  "content-action": _withCtx(({ props }) => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "text-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode($setup["AtomButton"], {
                              center: "text-center",
                              onClick: _withModifiers(($event: any) => ($setup.handleEdit(props, true)), ["stop"]),
                              class: "mx-auto w-100 rounded-pill",
                              text: 'Editar'
                            }, null, 8 /* PROPS */, ["onClick"])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "text-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode($setup["AtomButton"], {
                              center: "text-center",
                              onClick: _withModifiers(($event: any) => ($setup.handleCompany(props)), ["stop"]),
                              class: "mx-auto w-100 rounded-pill",
                              text: 'Gerenciar empresas'
                            }, null, 8 /* PROPS */, ["onClick"])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "text-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode($setup["AtomButton"], {
                              center: "text-center",
                              onClick: _withModifiers(($event: any) => ($setup.handleAdd(props)), ["stop"]),
                              class: "mx-auto w-100 rounded-pill",
                              text: 'Cadastro de grupos'
                            }, null, 8 /* PROPS */, ["onClick"])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "text-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode($setup["AtomButton"], {
                              center: "text-center",
                              onClick: _withModifiers(($event: any) => ($setup.handleDelete(props)), ["stop"]),
                              class: "mx-auto w-100 rounded-pill",
                              text: "Excluir",
                              background: "gray-05"
                            }, null, 8 /* PROPS */, ["onClick"])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["headers", "items", "totalItems", "perPage", "page"])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    ($setup.addNew && !$setup.manageGroup && !$setup.manageService)
      ? (_openBlock(), _createBlock(_component_v_container, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { class: "my-3" }, {
                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", { class: "text-gray-02" }, "Preencha todos os campos corretamente para cadastrar uma novo grupo.")
                    ], -1 /* HOISTED */)
                  ])),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomInput"], {
                      width: "100%",
                      required: "",
                      msgError: "Campo obrigatório",
                      hasError: !$setup.data?.nome,
                      placeholder: "Digite aqui",
                      label: "Nome do grupo",
                      modelValue: $setup.data.nome,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.data.nome) = $event))
                    }, null, 8 /* PROPS */, ["hasError", "modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomSelect"], {
                      multiple: "",
                      width: "100%",
                      placeholder: "Digite aqui",
                      label: "Empresas",
                      modelValue: $setup.data.companhiaIntLista,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.companhiaIntLista) = $event)),
                      options: $setup.empresas
                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "d-block"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomSelect"], {
                      multiple: "",
                      width: "100%",
                      placeholder: "Digite aqui",
                      label: "Serviços",
                      modelValue: $setup.data.servicoIntLista,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.data.servicoIntLista) = $event)),
                      options: $setup.servicos
                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_row, { class: "mt-5" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "text-center mt-5"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomButton"], {
                      center: "text-center",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.handleAddOrUpdate())),
                      class: "mx-auto w-100 rounded-pill",
                      text: $setup.type == 'C' ? 'Concluir Cadastro' : 'Concluir edição'
                    }, null, 8 /* PROPS */, ["text"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomButton"], {
                      center: "text-center",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (($setup.addNew = false), ($setup.type = ''), ($setup.data = {}))),
                      class: "mx-auto w-100 rounded-pill",
                      text: "Voltar",
                      background: "gray-05"
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    ($setup.manageGroup)
      ? (_openBlock(), _createBlock(_component_v_container, { key: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "12"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode($setup["AtomSelect"], {
                        width: "100%",
                        placeholder: "Selecione uma ou mais empresa",
                        modelValue: $setup.company,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.company) = $event)),
                        options: $setup.empresas,
                        multiple: true
                      }, null, 8 /* PROPS */, ["modelValue", "options"]),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode($setup["AtomButton"], {
                          class: "px-2",
                          onClick: $setup.setCompany
                        }, {
                          default: _withCtx(() => [
                            _createVNode($setup["PlusIcon"], { color: "white" })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ])
                    ])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_col, { md: "12" }, {
                  default: _withCtx(() => [
                    _createVNode($setup["MoleculeTable"], {
                      headers: $setup.headersCompany,
                      items: $setup.data.companhiaDTOLista,
                      pagination: false
                    }, {
                      actions: _withCtx(({ props }) => [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode($setup["AtomButton"], {
                            background: "white",
                            radius: "",
                            class: "pa-0",
                            onClick: _withModifiers(($event: any) => ($setup.handleDeleteCompany(props.row)), ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode($setup["DeleteIcon"])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["headers", "items"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomButton"], {
                      center: "text-center",
                      onClick: $setup.handleSaveCompany,
                      class: "mx-auto w-100 rounded-pill",
                      text: $setup.type == 'C' ? 'Concluir Cadastro' : 'Concluir Edição'
                    }, null, 8 /* PROPS */, ["text"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomButton"], {
                      center: "text-center",
                      onClick: _cache[11] || (_cache[11] = 
            () => {
              $setup.manageGroup = false;
              $setup.data = {};
            }
          ),
                      class: "mx-auto w-100 rounded-pill",
                      text: "Voltar",
                      background: "gray-05"
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    ($setup.manageService)
      ? (_openBlock(), _createBlock(_component_v_container, { key: 3 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "12"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode($setup["AtomSelect"], {
                        width: "100%",
                        placeholder: "Selecione um ou mais servico",
                        multiple: true,
                        modelValue: $setup.service,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.service) = $event)),
                        options: $setup.servicos
                      }, null, 8 /* PROPS */, ["modelValue", "options"]),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode($setup["AtomButton"], {
                          class: "px-2",
                          onClick: $setup.setService
                        }, {
                          default: _withCtx(() => [
                            _createVNode($setup["PlusIcon"], { color: "white" })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ])
                    ])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_col, { md: "12" }, {
                  default: _withCtx(() => [
                    _createVNode($setup["MoleculeTable"], {
                      headers: $setup.headersService,
                      items: $setup.data.servicoDTOLista,
                      pagination: false
                    }, {
                      actions: _withCtx(({ props }) => [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode($setup["AtomButton"], {
                            background: "white",
                            radius: "",
                            class: "pa-0",
                            onClick: _withModifiers(($event: any) => ($setup.handleDeleteService(props.row)), ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode($setup["DeleteIcon"])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["headers", "items"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomButton"], {
                      center: "text-center",
                      onClick: $setup.handleSaveService,
                      class: "mx-auto w-100 rounded-pill",
                      text: $setup.type == 'C' ? 'Concluir Cadastro' : 'Concluir Edição'
                    }, null, 8 /* PROPS */, ["text"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomButton"], {
                      center: "text-center",
                      onClick: _cache[13] || (_cache[13] = 
            () => {
              $setup.manageService = false;
              $setup.data = {};
            }
          ),
                      class: "mx-auto w-100 rounded-pill",
                      text: "Voltar",
                      background: "gray-05"
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["MoleculeModal"], {
      onHandleConfirm: $setup.handleAddOrUpdate,
      onHandleCancel: _cache[17] || (_cache[17] = ($event: any) => ($setup.showModalUpload = false)),
      title: "Cadastro de grupos",
      subtitle: 'Preencha todos os campos corretamente para cadastrar um novo grupo',
      show: $setup.showModalUpload,
      "btn-close-text": "Cancelar",
      "btn-confirm-text": "Registrar"
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode($setup["AtomInput"], {
                width: "100%",
                required: "",
                msgError: "Campo obrigatório",
                hasError: !$setup.data?.nome,
                placeholder: "Nome do grupo",
                label: "Nome do grupo",
                modelValue: $setup.data.nome,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.data.nome) = $event))
              }, null, 8 /* PROPS */, ["hasError", "modelValue"])
            ]),
            _createVNode($setup["AtomSelect"], {
              multiple: "",
              width: "100%",
              placeholder: "Selecione as empresas desse grupo",
              label: "Selecione as empresas desse grupo",
              modelValue: $setup.data.companhiaIntLista,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.data.companhiaIntLista) = $event)),
              options: $setup.empresas
            }, null, 8 /* PROPS */, ["modelValue", "options"]),
            _createVNode($setup["AtomSelect"], {
              multiple: "",
              width: "100%",
              placeholder: "Selecione os serviços desse grupo",
              label: "Selecione os serviços desse grupo",
              modelValue: $setup.data.servicoIntLista,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.data.servicoIntLista) = $event)),
              options: $setup.servicos
            }, null, 8 /* PROPS */, ["modelValue", "options"])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"]),
    _createVNode($setup["MoleculeModal"], {
      width: "700px",
      onHandleConfirm: $setup.handleSaveService,
      onHandleCancel: _cache[19] || (_cache[19] = ($event: any) => ($setup.showModalService = false)),
      title: "Gerenciar serviços",
      subtitle: 'Gerencie os serviços que esse grupo possui',
      show: $setup.showModalService,
      "btn-close-text": "Cancelar",
      "btn-confirm-text": "Salvar"
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "12"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode($setup["AtomSelect"], {
                      width: "100%",
                      placeholder: "Selecione um ou mais servico",
                      multiple: true,
                      modelValue: $setup.service,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.service) = $event)),
                      options: $setup.servicos
                    }, null, 8 /* PROPS */, ["modelValue", "options"]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode($setup["AtomButton"], {
                        class: "px-2",
                        onClick: $setup.setService
                      }, {
                        default: _withCtx(() => [
                          _createVNode($setup["PlusIcon"], { color: "white" })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ])
                  ])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_v_col, { md: "12" }, {
                default: _withCtx(() => [
                  _createVNode($setup["MoleculeTable"], {
                    headers: $setup.headersService,
                    items: $setup.data.servicoDTOLista,
                    pagination: false
                  }, {
                    actions: _withCtx(({ props }) => [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode($setup["AtomButton"], {
                          background: "white",
                          radius: "",
                          class: "pa-0",
                          onClick: _withModifiers(($event: any) => ($setup.handleDeleteService(props.row)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createVNode($setup["DeleteIcon"])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["headers", "items"])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"]),
    _createVNode($setup["MoleculeModal"], {
      onHandleConfirm: $setup.handleSaveCompany,
      onHandleCancel: _cache[21] || (_cache[21] = ($event: any) => ($setup.showModalCompany = false)),
      title: "Gerenciar empresas",
      subtitle: 'Gerencie as empresas que esse grupo possui',
      show: $setup.showModalCompany,
      "btn-close-text": "Cancelar",
      "btn-confirm-text": "Salvar"
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "12"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode($setup["AtomSelect"], {
                      width: "100%",
                      placeholder: "Selecione uma ou mais empresa",
                      modelValue: $setup.company,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.company) = $event)),
                      options: $setup.empresas,
                      multiple: true
                    }, null, 8 /* PROPS */, ["modelValue", "options"]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode($setup["AtomButton"], {
                        class: "px-2",
                        onClick: $setup.setCompany
                      }, {
                        default: _withCtx(() => [
                          _createVNode($setup["PlusIcon"], { color: "white" })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ])
                  ])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_v_col, { md: "12" }, {
                default: _withCtx(() => [
                  _createVNode($setup["MoleculeTable"], {
                    headers: $setup.headersCompany,
                    items: $setup.data.companhiaDTOLista,
                    pagination: false
                  }, {
                    actions: _withCtx(({ props }) => [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode($setup["AtomButton"], {
                          background: "white",
                          radius: "",
                          class: "pa-0",
                          onClick: _withModifiers(($event: any) => ($setup.handleDeleteCompany(props.row)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createVNode($setup["DeleteIcon"])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["headers", "items"])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"])
  ], 64 /* STABLE_FRAGMENT */))
}